import React, { useState, useCallback } from "react";
import Mealcard from "./Mealcard";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Mainpage() {
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  const [msg, setMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [lastQuery, setLastQuery] = useState("");

  // Handle input change
  const handleInput = (e) => {
    setSearch(e.target.value);
  };

  // API call with debouncing
  const fetchData = useCallback(async () => {
    if (search.trim() === "" || search === lastQuery) return;

    setMsg("");
    setIsLoading(true);
    setLastQuery(search);

    try {
      const response = await fetch(
        `https://www.themealdb.com/api/json/v1/1/search.php?s=${search}`
      );
      const jsonData = await response.json();

      if (!jsonData.meals) {
        setMsg("No data found");
        setData([]);
      } else {
        setData(jsonData.meals);
      }
    } catch (error) {
      setMsg("Something went wrong. Please try again.");
      setData(null);
    }

    setIsLoading(false);
    setSearch("");
  }, [search, lastQuery]);

  // Handle search trigger
  const handleSearch = () => {
    if (search.trim() === "") {
      setMsg("Please enter something");
      setData(null);
    } else {
      fetchData();
    }
  };

  return (
    <div
      className="position-relative min-vh-100 text-center bg-dark"
      style={{
        background: "url('https://source.unsplash.com/1600x900/?food') center/cover no-repeat",
      }}
    >
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
      <div className="position-relative py-5">
        <h1 className="text-white fw-bold display-4 bg-gradient text-warning d-inline-block px-3 py-2 rounded">
          🍽 Food Recipe App
        </h1>
      </div>
      <div className="container position-relative">
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="input-group shadow-lg rounded">
              <input
                type="text"
                className="form-control py-3 px-4 text-white bg-transparent border border-warning fs-5"
                placeholder="Search for a dish..."
                style={{ backdropFilter: "blur(10px)", height: "55px" }}
                onChange={handleInput}
                value={search}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                aria-label="Search for a meal"
              />
              <button
                className="btn btn-warning fw-bold fs-5 px-4"
                style={{ height: "55px" }}
                onClick={handleSearch}
                aria-label="Search button"
              >
                Search
              </button>
            </div>
          </div>
        </div>
        {msg && <h4 className="text-warning mt-3">{msg}</h4>}
        {isLoading && (
          <div className="mt-4">
            <div className="spinner-border text-warning" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        <div className="mt-4">
          <Mealcard detail={data} />
        </div>
      </div>
    </div>
  );
}
